import { Button, Card, Heading, Inline, Stack, Text } from '@etg/wings';
import { Pictogram } from '@eti/components';
import { useDirection, useSiteContext, useTranslation } from '@eti/providers';
import { CO2_COMPENSATION, getProductPictogramId, productIds } from '@eti/products';
import { Link } from 'react-router-dom';
import type { AvailableExtraProductType } from '../../models';
import { routes } from '../../../../constants/routesAndApisConstants';

interface CO2CompensationBannerProps {
  product: AvailableExtraProductType;
}

const CO2CompensationBanner = ({ product }: CO2CompensationBannerProps) => {
  const { t } = useTranslation();
  const { brand } = useSiteContext();
  const isRTL = useDirection();

  return (
    <Card data-testid="co2-compensation-banner">
      <Stack spacing={24}>
        <Stack spacing={8}>
          <Pictogram
            brand={brand.code}
            data-testid="co2-compensation-banner-icon"
            id={getProductPictogramId(productIds[CO2_COMPENSATION.id], isRTL)}
            size="2rem"
          />
          <Heading as="h2" level={4}>
            {product.name}
          </Heading>
          <Text>{t('Overview.CO2Compensation.Banner.Description')}</Text>
        </Stack>
        <Inline align="start">
          <Button
            as={Link}
            data-testid="co2-compensation-banner-link"
            to={`${routes.ORDER_DETAILS_EXTRA_PRODUCTS}#product-id-${CO2_COMPENSATION.id}`}
          >
            {t('Overview.CO2Compensation.Banner.Button.Text')}
          </Button>
        </Inline>
      </Stack>
    </Card>
  );
};

export default CO2CompensationBanner;
